import { useEffect } from "react";
import Lenis from "lenis";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Projects from "@/components/site/Projects";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Portfolio() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <main data-testid="portfolio-page" className="bg-ink text-bone grain">
      <Hero />
      <Marquee />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </main>
  );
}
